import { FaAngleRight } from "react-icons/fa6";
import { MdOutlineKeyboardBackspace } from "react-icons/md";
import { Link } from "react-router-dom";
import { useState } from "react";
import VendorTable from "../Restaurants/Operations/RestaurantMgt/VendorTable";

type TabType = "active" | "suspended" | "appeal";

const RestaurantManagement = () => {
  const [activeTab, setActiveTab] = useState<TabType>("active");

  const getTabDescription = () => {
    switch (activeTab) {
      case "active":
        return "Overview of active restaurants on the platform";
      case "suspended":
        return "Manage suspended restaurants and review suspension reasons";
      case "appeal":
        return "Review appeals from suspended restaurants";
      default:
        return "Overview of FoodBank Restaurant platform operations and key metrics.";
    }
  };

  const getTabTitle = () => {
    switch (activeTab) {
      case "active":
        return "Active Restaurants";
      case "suspended":
        return "Suspended";
      case "appeal":
        return "Appeal";
      default:
        return "Restaurant Management";
    }
  };

  return (
    <section className="font-mont">
      <div className="flex items-start gap-4">
        <Link to="/dashboard/restaurants">
          <button className="cursor-pointer p-2 rounded-full bg-[#008B5014]">
            <MdOutlineKeyboardBackspace className="w-6 h-6" />
          </button>
        </Link>
        <article>
          <h1 className="text-2xl font-medium mb-2 inline-flex items-center gap-3">
            <span className="font-semibold">Operations</span> <FaAngleRight />
            Restaurant Management
          </h1>
          <p className="text-sm">
            {getTabDescription()}
          </p>
        </article>
      </div>
      
      <section className="bg-[#EEEEEE40] px-3 py-5 my-3">
        {/* Tab Navigation */}
        <nav className="bg-white p-5 w-fit mb-5">
          <ul className="flex gap-10 text-base font-medium">
            <li>
              <button
                type="button"
                className={`cursor-pointer p-2 ${
                  activeTab === "active" ? "bg-[#EEEEEE40] text-secondary" : "text-gray-600"
                }`}
                onClick={() => setActiveTab("active")}
              >
                Active Restaurants
              </button>
            </li>
            <li>
              <button
                type="button"
                className={`cursor-pointer p-2 ${
                  activeTab === "suspended" ? "bg-[#EEEEEE40] text-secondary" : "text-gray-600"
                }`}
                onClick={() => setActiveTab("suspended")}
              >
                Suspended
              </button>
            </li>
            <li>
              <button
                type="button"
                className={`cursor-pointer p-2 ${
                  activeTab === "appeal" ? "bg-[#EEEEEE40] text-secondary" : "text-gray-600"
                }`}
                onClick={() => setActiveTab("appeal")}
              >
                Appeal
              </button>
            </li>
          </ul>
        </nav>

        <p className="text-[10px] text-secondary py-4">
          *Manage vendor onboarding, approvals, and account status.
        </p>
        
        {/* Tab Content */}
        <VendorTable activeTab={activeTab} />
      </section>
    </section>
  );
};

export default RestaurantManagement;